import { css } from "@emotion/react";

export const arrowIconStyle = css`
  align-items: center;
  color: #000;
  display: flex;
`;

export const bottomContentsStyle = css`
  align-items: center;
  display: flex;
  height: 73px;
  justify-content: space-between;
`;

export const bottomLeftContentsStyle = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 8px;
`;

export const countBadgeStyle = css`
  align-items: center;
  background-color: #fff;
  border-radius: 50%;
  bottom: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
  color: #000;
  display: grid;
  font-size: 16px;
  font-weight: 700;
  height: 24px;
  justify-content: center;
  line-height: 24px;
  position: absolute;
  right: 3px;
  width: 24px;
`;

export const dateStyle = css`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

export const headerStyle = css`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const imageStyle = css`
  height: 113px;
  object-fit: cover;
  width: 113px;
`;

export const imageWrapperStyle = css`
  align-items: center;
  background-color: #f5f5f5;
  display: flex;
  height: 113px;
  justify-content: center;
  position: relative;
  width: 113px;
`;

export const orderNumberStyle = css`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const rightContentsStyle = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  row-gap: 16px;
`;

export const rootStyle = css`
  background-color: #fff;
  border: 1px solid #d4d4d4;
  color: inherit;
  column-gap: 16px;
  cursor: pointer;
  display: flex;
  padding: 15px;
  position: relative;
  text-decoration: none;
  width: 100%;
`;

export const settlementStatusStyle = css`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const settlementStatusUnpaidStyle = css`
  color: #e53e3e;
`;
